import React from 'react';
import {StyleSheet, useWindowDimensions} from 'react-native';
import Svg, {
  Circle,
  Defs,
  Pattern,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg';
import {colors} from '../config/theme';

// Full-screen auth background: an emerald glow centred behind the hero
// plus a faint 24pt dot grid. Purely decorative; sits under the content.
const AuthBackdrop = ({glowY = 0.28}) => {
  const {width, height} = useWindowDimensions();
  const cx = width / 2;
  const cy = height * glowY;
  // CSS `radial-gradient(circle …)` sizes to the farthest corner.
  const r = Math.hypot(cx, height - cy);
  return (
    <Svg
      style={StyleSheet.absoluteFill}
      width={width}
      height={height}
      pointerEvents="none">
      <Defs>
        <RadialGradient
          id="authGlow"
          gradientUnits="userSpaceOnUse"
          cx={cx}
          cy={cy}
          fx={cx}
          fy={cy}
          r={r}>
          <Stop offset="0" stopColor={colors.secondary} stopOpacity={0.15} />
          <Stop offset="0.5" stopColor={colors.brandBright} stopOpacity={0.04} />
          <Stop offset="0.75" stopColor={colors.brandBright} stopOpacity={0} />
        </RadialGradient>
        <Pattern
          id="authDots"
          patternUnits="userSpaceOnUse"
          width={24}
          height={24}>
          <Circle cx={12} cy={12} r={1} fill={colors.secondary} />
        </Pattern>
      </Defs>
      <Rect width={width} height={height} fill="url(#authGlow)" />
      <Rect
        width={width}
        height={height}
        fill="url(#authDots)"
        opacity={0.05}
      />
    </Svg>
  );
};

export default AuthBackdrop;
